// extracted by mini-css-extract-plugin
module.exports = {"pricing":"src-components-Pricing-PricingComponent-index-module__pricing--m2clf"};